import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogConfiguration } from '../interfaces/dialog-configuration.interface';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent {
  public configuration: DialogConfiguration;
  public updatePrice = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogConfiguration,
    public dialogReference: MatDialogRef<ConfirmationComponent>
  ) {
    this.configuration = {
      title: data.title,
      question: data.question
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit() { }
}
